<template>
  <q-page class="container" padding>
    <TableComponentMovimentacao :atualizar="atualizar" />
  </q-page>
</template>

<script>
import { ref } from "vue";

import TableComponentMovimentacao from "../components/TableComponentMovimentacao.vue";
//import { useStore } from "vuex";
//import { useQuasar } from "quasar";

// import { useRouter } from "vue-router";
export default {
  components: {
    TableComponentMovimentacao,
  },
  name: "CadastrarGrupo",
  setup() {
    const ferramenta = ref({
      uuid: "",
      nome: "",
      status: "",
    });
    const file = ref(null);
    const atualizar = ref(0);

    const atualizaLista = ref(false);
    //const $q = useQuasar();
    // const myForm = ref(null);
    //const store = useStore();
    // const router = useRouter();

    let injectFerramenta = async (value) => {
      ferramenta.value.nome = value.value[0].nome;
      ferramenta.value.status = value.value[0].status;
      ferramenta.value.uuid = value.value[0].uuid;
    };

    let injectStatus = async (value) => {
      atualizar.value++;
      ferramenta.value.status = value.value;
    };

    return {
      movimentaStatus: ref(false),
      atualizaLista,
      injectFerramenta,
      injectStatus,
      ferramenta,
      file,
      atualizar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.comentarioUP {
  width: 100%;
  height: 40px;

  outline-color: #58afc1;
}
</style>
